import { render, staticRenderFns } from "./templateForm.vue?vue&type=template&id=5d2cc293&"
import script from "./templateForm.vue?vue&type=script&lang=js&"
export * from "./templateForm.vue?vue&type=script&lang=js&"
import style0 from "./templateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports